import { HeroLayoutOptions } from '../components/Hero/src/DynamicHero/DynamicHero.types'
import { getValueListBgColor, getValueListContrastColor } from './background-util'
import { setTextAlignment } from './text-util'

export const setFlexAlignment = (alignment: string) => {
  const glyphs = {
    /* from value list */
    left: 'u-lg-flex u-lg-flexAlignItemsStart u-lg-flexJustifyStart',
    center: 'u-lg-flex u-lg-flexAlignItemsCenter u-lg-flexJustifyCenter',
    right: 'u-lg-flex u-lg-flexAlignItemsStart',
    bottomRight: 'u-lg-flex u-lg-flexAlignItemsEnd u-lg-flexJustifyEnd',
    bottomLeft: 'u-lg-flex u-lg-flexAlignItemsEnd',
  }
  if (glyphs[alignment as keyof typeof glyphs]) {
    return glyphs[alignment as keyof typeof glyphs]
  }
  return 'u-lg-flex u-lg-flexAlignItemsStart u-lg-flexJustifyStart'
}

export const setFlexVerticalAlignment = (alignment: string) => {
  const glyphs = {
    /* from value list */
    verticalRightTop: 'u-lg-flexAlignItemsStart u-lg-flexJustifyCenter',
    verticalLeftTop: 'u-lg-flexAlignItemsStart u-lg-flexJustifyStart',
    verticalRightHeightFull: 'u-lg-flexAlignItemsEnd OverlayHeightFull',
    verticalLeftHeightFull: 'OverlayHeightFull',
    verticalLeftCenter: 'u-flexAlignItemsCenter u-lg-flexJustifyStart',
    verticalRightCenter: 'u-flexAlignItemsCenter u-lg-flexJustifyEnd',
    verticalBottomRight: 'u-lg-flexAlignItemsEnd u-lg-flexJustifyEnd',
  }
  if (glyphs[alignment as keyof typeof glyphs]) {
    return glyphs[alignment as keyof typeof glyphs]
  }
  return 'u-lg-flexAlignItemsStart u-lg-flexJustifyStart' //TopLeft
}

export const setImageBackgroundPosition = (position: string) => {
  const glyphs = {
    /* from value list */
    contain: 'u-bgSizeContain',
    full: 'u-bgSizeFull',
    bottom: 'u-bgPosBottom',
    top: 'u-bgPosTop',
    left: 'u-bgPosLeft',
    center: 'u-bgPosCenter',
    custom015: 'u-bgPosCustom015',
    cover: 'u-bgSizeCover',
  }
  if (glyphs[position as keyof typeof glyphs]) {
    return glyphs[position as keyof typeof glyphs]
  }
  return 'u-bgSizeContain'
}

export const setVerticalSpacing = (spacing: string) => {
  let glyphs = {
    'Default': 'u-paddingVert0',
    'No top spacing': 'u-paddingTop0',
    'No bottom spacing': 'u-paddingBottom0',
    'Top 1gu': 'u-paddingTop1gu',
    'Top 2gu': 'u-paddingTop2gu',
    'Top 4gu': 'u-paddingTop4gu',
    'Top 5gu': 'u-paddingTop5gu',
    'Top 10gu': 'u-paddingTop10gu',
    'Bottom 1gu': 'u-paddingBottom1gu',
    'Bottom 2gu': 'u-paddingBottom2gu',
    'Bottom 4gu': 'u-paddingBottom4gu',
    'Bottom 5gu': 'u-paddingBottom5gu',
    'Bottom 10gu': 'u-paddingBottom10gu',
    'Vertical 2gu': 'u-paddingVert2gu',
    'Vertical 4gu': 'u-paddingVert4gu',
    'Vertical 5gu': 'u-paddingVert5gu',
    'Vertical 10gu': 'u-paddingVert10gu',
    'None': '',
  }
  const space = glyphs[spacing as keyof typeof glyphs]
  return space || ''
}

export const setConfigVertSpacing = (layoutConfigs: { verticalSpacing?: string } = {}) => {
  if (layoutConfigs.verticalSpacing) {
    return ' ' + setVerticalSpacing(layoutConfigs.verticalSpacing)
  } else {
    return ' u-paddingVert10gu '
  }
}

export const setConfigBgColorClass = (
  layoutConfigs: { globalBgColor?: { color?: string } } = {}
) => {
  return layoutConfigs.globalBgColor && layoutConfigs.globalBgColor.color
    ? getValueListBgColor(layoutConfigs.globalBgColor.color)
    : ''
}

export const setBgContrastClass = (layoutConfigs: { globalBgColor?: { color?: string } } = {}) => {
  return layoutConfigs.globalBgColor && layoutConfigs.globalBgColor.color
    ? getValueListContrastColor(layoutConfigs.globalBgColor.color)
    : ''
}

export const setContentAlignment = (
  layoutConfigs: { textAlignment?: { alignment?: string } } = {}
) => {
  if (layoutConfigs && layoutConfigs?.textAlignment?.alignment) {
    return ' ' + setTextAlignment(layoutConfigs.textAlignment.alignment)
  } else {
    return ' u-textLeft '
  }
}
export const setLayoutAlignment = (layout: HeroLayoutOptions, column: 'right' | 'left'): string => {
  switch (layout) {
    case '50 - 50': {
      return 'u-size6of12'
    }
    case '67 - 33': {
      if (column === 'left') {
        return 'u-size8of12'
      }
      return 'u-size4of12'
    }
    default: {
      return 'u-size12of12'
    }
  }
}
